<template>
  <div id="smartTown">
    <div class="title">海南自由贸易港建设总体方案</div>
    <div class="text">加强公共卫生防控救治体系建设，建立传染病和突发公共卫生事件监测预警、应急响应平台和决策指挥系统，提高早期预防、风险研判和及时处置能力。加强疾病预防控制体系建设，高标准建设省级疾病预防控制中心，建立国家热带病研究中心海南分中心，加快推进各级疾病预防控制机构基础设施建设，优化实验室检验检测资源配置。加强公共卫生人才队伍建设，提升监测预警、检验检测、现场流行病学调查、应急处置和医疗救治能力。</div>
    <div class="btn" @click="toLink()">查看详情</div>
   
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
  methods:{
    toLink(){
      window.open('http://www.gov.cn/zhengce/2020-06/01/content_5516608.htm')
    }
  }
};
</script>
<style scoped>
.btn{
  margin: 40px auto 20px;
  display: block;
  border-radius: 4px;
  width: 80px;
  color: #1e73be;
  border: 1px solid #1e73be;
}
.btn:hover{
  color: #1e73be ;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-top: 15px;
  margin-right: 20px;
  text-indent: 28px
}
.sub-title{
  color: #666;
  font-size: 18px;
  text-align: center;
}
.right{
  text-align: right;
  color: #666;
  font-size: 20px;
}
.title{
  font-weight: bold;
  font-size: 24px;
  margin-top: 10px;
  text-align: center;
}
.title1{
  font-weight: bold;
  font-size: 26px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/view/news4.vue